import Navbar from './Navbar';
import Footer from './Footer';
import PageHero from './PageHero';
import ProductCard from './ProductCard';
import Formular from './Formular';
import { ScrollRestoration } from 'react-router-dom';
import kamenivo04 from '../resources/Kamenivo 0-4.jpeg';
import kamenivo032 from '../resources/Kamenivo 0-32.jpeg';
import kamenivo063 from '../resources/Kamenivo 0-63.jpeg';
import kamenivo48B from '../resources/Kamenivo 4-8 B.jpeg';
import kamenivo0408 from '../resources/Kamenivo 4-8.jpeg';
import kamenivo0816 from '../resources/Kamenivo 8-16.jpeg';
import kamenivo1632 from '../resources/Kamenivo 16-32.jpeg';
import kamenivo3263 from '../resources/Kamenivo 32-63.jpeg';
import kamenivo1632M from '../resources/16-32 Maglovec.jpg';
import kamenivo1622 from '../resources/16-22 Sedlice -24,60€.jpg';

const items = [
    'Frakcia 0/4 Kamenivo',
    'Frakcia 4/8B Kamenivo',
    'Frakcia 4/8 Kamenivo',
    'Frakcia 8/16 Kamenivo',
    'Frakcia 0/32 Kamenivo',
    'Frakcia 16/32 Kamenivo',
    'Frakcia 0/63 Kamenivo',
    'Frakcia 32/63 Kamenivo',
    'Frakcia 63/120 Kamenivo',
];

const cards = [
    {
        img: kamenivo04,
        badge: 'Kamenivo',
        title: 'Frakcia 0/4',
        description: 'Vhodný ako podkladová vrstva pod exteriérovú dlažbu, zhutňujúca vrstva, na obsypanie vodovodných a kanalizačných potrubí.',
        tableRows: [{ label: 'Cena za t', bezDph: '13,29 €', sDph: '16,35 €' }],
    },
    {
        img: kamenivo48B,
        badge: 'Kamenivo',
        title: 'Frakcia 4/8B',
        description: 'Vhodný ako podkladová vrstva pod exteriérovú dlažbu, zhutňujúca vrstva.',
        tableRows: [{ label: 'Cena za t', bezDph: '17,48 €', sDph: '21,50 €' }],
    },
    {
        img: kamenivo0408,
        badge: 'Kamenivo',
        title: 'Frakcia 4/8',
        description: 'Vhodný ako podkladová vrstva pod exteriérovú dlažbu, zhutňujúca vrstva, výroba betónov s nižšou triedou, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '24,23 €', sDph: '29,80 €' }],
    },
    {
        img: kamenivo0816,
        badge: 'Kamenivo',
        title: 'Frakcia 8/16',
        description: 'Vhodný ako podkladová vrstva pod exteriérovú dlažbu, zhutňujúca vrstva, výroba betónov s nižšou triedou, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '24,88 €', sDph: '30,60 €' }],
    },
    {
        img: kamenivo032,
        badge: 'Kamenivo',
        title: 'Frakcia 0/32',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, zhutňujúca vrstva.',
        tableRows: [{ label: 'Cena za t', bezDph: '14,63 €', sDph: '18,00 €' }],
    },
    {
        img: kamenivo1622,
        badge: 'Kamenivo',
        title: 'Frakcia 16/22 – Sedlice',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, násyp do pohľadových gabiónov.',
        tableRows: [{ label: 'Cena za t', bezDph: '26,42 €', sDph: '32,50 €' }],
    },
    {
        img: kamenivo1632,
        badge: 'Kamenivo',
        title: 'Frakcia 16/32 – Sedlica',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, zhutňujúca vrstva, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '26,42 €', sDph: '32,50 €' }],
    },
    {
        img: kamenivo1632M,
        badge: 'Kamenivo',
        title: 'Frakcia 16/32 – Maglovec',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, zhutňujúca vrstva, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '21,46 €', sDph: '26,40 €' }],
    },
    {
        img: kamenivo063,
        badge: 'Kamenivo',
        title: 'Frakcia 0/63',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, zhutňujúca vrstva, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '14,55 €', sDph: '17,90 €' }],
    },
    {
        img: kamenivo3263,
        badge: 'Kamenivo',
        title: 'Frakcia 32/63',
        description: 'Vhodný ako podkladová vrstva pre spevnené plochy s vyšším stupňom zaťaženia, pod exteriérovú dlažbu, zhutňujúca vrstva, drenážne zásypy.',
        tableRows: [{ label: 'Cena za t', bezDph: '19,19 €', sDph: '23,60 €' }],
    },
];

function Kamenivo() {
    return (
        <div>
            <Navbar />
            <PageHero
                title="Naša"
                highlight="ponuka"
                subtitle="Drvené kamenivo – pevný základ každej stavby."
            />
            <div className="max-w-screen-xl mx-auto px-6 py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {cards.map((card, i) => (
                    <ProductCard key={i} {...card} />
                ))}
            </div>
            <Formular napln={items} />
            <Footer />
            <ScrollRestoration />
        </div>
    );
}

export default Kamenivo;
